import { Link } from "react-router-dom";
import { BrandLockup } from "@/components/layout/BrandLockup";
import { useAuthStore } from "@/state/authStore";

export function NotFoundPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="border-b border-zinc-800/60 px-6 py-4">
        <Link to={isAuthenticated ? "/dashboard" : "/"} className="hover:opacity-80 transition-opacity inline-block">
          <BrandLockup size="sm" />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="text-center max-w-sm">
          <p className="text-7xl font-bold text-zinc-800 mb-6 select-none">404</p>
          <h1 className="text-2xl font-bold text-white mb-3">Page not found</h1>
          <p className="text-zinc-400 text-sm mb-8 leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
          </p>
          <Link
            to={isAuthenticated ? "/dashboard" : "/"}
            className="inline-block px-6 py-3 bg-[rgb(var(--cp))] hover:bg-[rgb(var(--cp)/0.85)] text-white font-semibold rounded-lg transition-colors"
          >
            {isAuthenticated ? "Back to Dashboard" : "Back to Home"}
          </Link>
        </div>
      </main>
    </div>
  );
}
